import React, { useState } from "react";
import { CustomizationCarousel } from "./common/CustomizationCarousel";
import { MarkerPreview } from "./MarkerPreview";
import { ColorPickerWithPresets } from './common/ColorPickerWithPresets';
import { AdvancedSettings } from './common/AdvancedSettings';
import styled from 'styled-components';
import { Frame } from '../types';

interface MarkerCustomizationProps {
  markerShape: string;
  setMarkerShape: (shape: string) => void;
  markerColor: string;
  setMarkerColor: (color: string) => void;
}

export const MarkerCustomization: React.FC<MarkerCustomizationProps> = ({
  markerShape,
  setMarkerShape,
  markerColor,
  setMarkerColor,
}) => {
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  const markerOptions = [
    { value: 'marker-square', label: 'Square' },
    { value: 'marker-dot', label: 'Dot' },
    { value: 'marker-rounded', label: 'Rounded' },
    { value: 'marker-diamond', label: 'Diamond' },
    { value: 'marker-flower', label: 'Flower' },
    { value: 'marker-cross', label: 'Cross' },
    { value: 'marker-target', label: 'Target' },
    { value: 'marker-hexagon', label: 'Hexagon' },
    { value: 'marker-star', label: 'Star' },
  ];

  const itemsPerPage = 6;
  const totalPages = Math.ceil(markerOptions.length / itemsPerPage);

  return (
    <Section>
      <CustomizationCarousel 
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
        itemsPerPage={itemsPerPage}
      >
        {markerOptions
          .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage)
          .map((option) => (
            <OptionBox
              key={option.value}
              active={markerShape === option.value}
              onClick={() => setMarkerShape(option.value)}
            >
              <PreviewContainer>
                <MarkerPreview
                  styleType={option.value}
                  markerColor={markerColor}
                />
              </PreviewContainer>
              <OptionLabel>{option.label}</OptionLabel>
            </OptionBox>
        ))}
      </CustomizationCarousel>

      <AdvancedSettings
        showAdvanced={showAdvanced}
        setShowAdvanced={setShowAdvanced}
        titlePrefix="Advanced Marker"
      >
        <ColorPickerWithPresets
          label="Marker Color"
          color={markerColor}
          onChange={setMarkerColor}
        />
      </AdvancedSettings>
    </Section>
  );
};

const Section = styled.section`
  margin-top: 24px;
`;

const OptionBox = styled.button<{ active: boolean }>`
  min-width: 120px;
  height: 120px;
  background: white;
  border: 2px solid ${props => props.active ? '#ff6320' : '#e9ecef'};
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  &:hover {
    border-color: #ff6320;
  }
`;

const PreviewContainer = styled.div`
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OptionLabel = styled.span`
  font-size: 12px;
  color: #666;
  text-align: center;
`;
